'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalTransitionContextPropType = exports.ConsumesModalTransitionContext = exports.ModalTransitionContextProvider = exports.ModalTransitionContextConsumer = exports.ModalTransitionContext = exports.defaultModalTransitionContext = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
  transitioning: _react.PropTypes.bool.isRequired
};

var defaultModalTransitionContext = exports.defaultModalTransitionContext = {
  transitioning: false
};

var ModalTransitionContext = exports.ModalTransitionContext = _react2.default.createContext(defaultModalTransitionContext);

var ModalTransitionContextConsumer = ModalTransitionContext.Consumer,
    ModalTransitionContextProvider = ModalTransitionContext.Provider;
exports.ModalTransitionContextConsumer = ModalTransitionContextConsumer;
exports.ModalTransitionContextProvider = ModalTransitionContextProvider;
var ConsumesModalTransitionContext = exports.ConsumesModalTransitionContext = (0, _consumerDecoratorFactory2.default)('modalTransition', ModalTransitionContextConsumer);

var modalTransitionContextPropType = exports.modalTransitionContextPropType = _react.PropTypes.shape(types);